var _g, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgRockyLinux1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2248_58705)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.1014 21.2765C31.678 19.6245 31.9914 17.8489 31.9914 16C31.9914 7.16341 24.8314 0 15.9994 0C7.16743 0 0.0078125 7.16341 0.0078125 16C0.0078125 20.3723 1.76094 24.335 4.60191 27.2231L20.8234 10.9929L24.8282 15.0001L31.1014 21.2765ZM28.1805 26.3677L20.8234 19.0069L9.30276 30.5338C11.3397 31.4748 13.6082 32 15.9994 32C20.8786 32 25.2472 29.8141 28.1805 26.3677Z",
    fill: "#10B981"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2248_58705"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRockyLinux1);
export default __webpack_public_path__ + "static/media/rocky-linux 1.11c13cdcf602e48746b492a9d7cd1eb7.svg";
export { ForwardRef as ReactComponent };